export default __webpack_public_path__ + "static/media/05.f43e5262.png";